import { Enumerable } from '../decorators/enumerable';
import { Kb3dModel } from '../decorators/kb3d-decorator';
import { IMeshGroupNode } from '../kb3d-models';
import { Kb3dObject } from '../kb3d-object';
import { Token } from '../token';
import { SpaceNode } from './space-node';

@Kb3dModel<MeshGroupNode>({
    token: Token.MeshGroupNode,
})
export class MeshGroupNode extends SpaceNode implements IMeshGroupNode {
    constructor() {
        super();
    }

    private _meshes: SpaceNode[];
    @Enumerable()
    public get meshes(): SpaceNode[] {
        if (!this._meshes) this._meshes = [];
        return this._meshes;
    }
    public set meshes(val) {
        this._meshes = val;
    }

    public getChildren(): Kb3dObject[] {
        return super.getChildren().concat(this.meshes);
    }

    public getChildArrayForType(token: Token): Kb3dObject[] | undefined {
        if (token.isMeshOrGroup() || token.isLight()) {
            return this.meshes;
        } else if (token.isConnector()) {
            return this.connectors;
        } else {
            throw 'unexpected token';
        }
    }

    public getSpaceChildren() {
        return this.meshes;
    }
}
